import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { ItemClasificationCatalogTodos } from 'src/mocks/ItemsclasificationCatalog';
import { SpinnerNames } from '../constants/spinners';
import { IcatalogClassification } from '../model/http/catalogs';
import {
  AdvisorDownloadClients,
  AdvisorInfoSAPResponse,
  IClientDoctorRes,
  RequestAdvisorModel,
} from '../model/http/clientDoctorModel';
import { BaseResponseHttp } from '../model/http/commons.model';
import { IGeneralResponse } from '../model/http/general-response.model';
import { SaveAdviserProfilePhoto } from '../model/local/saveAdviserPhoto';
import { ConsumeService } from './consume.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AdvisorInformationService {
  constructor(
    private consumeService: ConsumeService,
    private localStorageService: LocalStorageService
  ) {}

  getListDoctorInfo(
    queryParams: string,
    spinnerName: SpinnerNames
  ): Observable<IClientDoctorRes> {
    return this.consumeService.httpGet<IClientDoctorRes>(
      `${Endpoints.advisorInfo.getListDoctors}${queryParams}`,
      null,
      null,
      spinnerName
    );
  }

  sendInvitationDoctor(
    queryParams: RequestAdvisorModel
  ): Observable<BaseResponseHttp> {
    return this.consumeService.httpPost<BaseResponseHttp>(
      `${Endpoints.advisorInfo.sendInvitationDoctor}`,
      queryParams
    );
  }
  getAdvisorInfoFromSAP(): Observable<AdvisorInfoSAPResponse> {
    return this.consumeService.httpGet<AdvisorInfoSAPResponse>(
      `${
        Endpoints.advisorInfo.advisorInfo
      }${this.localStorageService.getCardCode()}`
    );
  }

  updateProfilePhotoAdviser(
    updatePhoto: SaveAdviserProfilePhoto
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.profileAdviser.saveProfilePhoto}`,
      updatePhoto
    );
  }

  downloadDoctorsList(params: string): Observable<AdvisorDownloadClients> {
    return this.consumeService.httpGet(
      `${Endpoints.profileAdviser.downloadDoctors}?${params}`
    );
  }

  getAdvisorCatalogs(line: string): Observable<IcatalogClassification> {
    return this.consumeService.httpGet(
      `${Endpoints.advisor.getCatalogs}?line=${line}`
    );
  }
}
